import { render, staticRenderFns } from "./MemberCompetencies.vue?vue&type=template&id=1a787e86&scoped=true"
import script from "./MemberCompetencies.vue?vue&type=script&lang=js"
export * from "./MemberCompetencies.vue?vue&type=script&lang=js"
import style0 from "./MemberCompetencies.vue?vue&type=style&index=0&id=1a787e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a787e86",
  null
  
)

export default component.exports